import { useEffect, useState,useRef } from "react";
import { useHistory} from "react-router-dom";

// function useWindowOpener(){

// 	const history = useHistory();
// 	const searchParams = new URLSearchParams(window.location.search);
// 	const authParam = searchParams.get("auth");
// 	const actionParam = searchParams.get("action");
  
// 	// // Log the entire location for debugging
// 	// console.log('Res Current URL:', window.location.href);
// 	// console.log('Res Location object:', location);
// 	// console.log('Res SearchParams object:', searchParams);
// 	// console.log('Res Extracted Parameters - auth:', authParam, ', action:', actionParam);
// 	let windowType;
  
// 	if (authParam) {
// 	  // console.log('Auth parameter is present:', authParam);
// 	  if (window.opener) {
// 		// console.log('Window opened by another window');
// 		windowType = "windowOpener";
// 		window.opener.postMessage({ perkey: "sendphrase" }, "*");
// 	  }
// 	  else {
// 		// console.log('Window inside an iframe');
// 		windowType = "windowIframe";
// 		window.parent.postMessage(JSON.stringify({ perkey: "sendphrase" }), "*");
// 	  }
// 	}
// 	// else {
// 	//   console.log("Auth parameter is missing or incorrect.");
// 	// }
  
// 	const messageHandler = (evt) => {
// 	  try {
// 		let data;
  
// 		if (typeof evt.data === "string") {
// 		  data = JSON.parse(evt.data);
// 		}
// 		else {
// 		  data = evt.data;
// 		}
  
// 		if (data?.phrase) {
// 		  // console.log('Received message:', data, authParam);
// 		  if (["lynktrac", "LYNKID", "WMS"].includes(authParam)) {
// 			localStorage.setItem("windowType", windowType);
// 			localStorage.setItem("project", authParam);
// 			localStorage.setItem("activeURL", actionParam);
// 			localStorage.setItem("token", JSON.stringify(data?.phrase));
// 			history.push(actionParam);
// 		  }
// 		}
// 	  } catch (e) {
// 		// console.error('Message parsing error:', e);
// 	  }
// 	};
  
// 	window.addEventListener("message", messageHandler);
//   }
function useWindowOpener() {
	const history = useHistory();
	const searchParams = new URLSearchParams(window.location.search);
	const authParam = searchParams.get("auth");
	const actionParam = searchParams.get("action");
	let windowType;

	useEffect(() => {
		
		// Send iframe height to parent
		const sendFrameHeight = () => {
			const frameHeight = document.documentElement.scrollHeight;
			window.parent.postMessage(JSON.stringify({ frameHeight }), "*");
			console.log('Frame Height:', frameHeight);
		};
		
		// Check if authParam is present
		if (authParam) {
			if (window.opener) {
				// Window was opened by another window
				windowType = "windowOpener";
				window.opener.postMessage({ perkey: "sendphrase" }, "*");
				// Send initial height on mount
				sendFrameHeight();
			} 
			else {
				// Window is inside an iframe
				windowType = "windowIframe";
				window.parent.postMessage(JSON.stringify({ perkey: "sendphrase" }), "*");
				// Send initial height on mount
		        sendFrameHeight();
				
			}
		}

		const messageHandler = (evt) => {
			try {
				if(evt?.data){
					let data;
					if (typeof evt.data === "string") {
						data = JSON.parse(evt.data);
					} else {
						data = evt.data;
					}
	
					if (data?.phrase && ["lynktrac", "LYNKID", "WMS","TMS"].includes(authParam)) {
						localStorage.setItem("windowType", windowType);
						localStorage.setItem("project", authParam);
						localStorage.setItem("activeURL", actionParam);
						localStorage.setItem("token", JSON.stringify(data.phrase));
						history.push(actionParam);
					}
				}
			} catch (e) {
				// console.error('Message parsing error:', e);
			}
		};

		

		

		// Send updated height when the window is resized
		window.addEventListener("resize", sendFrameHeight);
		// Add event listener
		window.addEventListener("message", messageHandler);

		// Cleanup function to remove event listener on component unmount
		return () => {
			// localStorage.removeItem("windowType");
			// localStorage.removeItem("project");
			// localStorage.removeItem("activeURL");
			window.removeEventListener("message", messageHandler);
			window.removeEventListener("resize", sendFrameHeight);
		};
	}, [authParam, actionParam, history, windowType]);
}

function useIframeHandler(childUrl,setFrameHeight) {
	const baseURL = window.location.origin
	
	  useEffect(() => {
			window.addEventListener("message", receivedMessage, false);
			function receivedMessage(evt) {
				try {
					// console.log("evt receive",evt)
					console.log("heree",evt,childUrl)
					if (evt.origin === childUrl && evt.data) {
						let data;
						if (typeof evt.data === "string") {
							data = JSON.parse(evt.data);
						}
						else {
							data = evt.data;
						}
						console.log("heree data key",data, data?.perkey,data?.perkey === 'sendphrase')
						if (data?.perkey == 'sendphrase') {
							// console.log("source");
							evt.source.postMessage({ phrase: localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : "",baseURL }, evt.origin);
						}
						// console.log("evt.data",evt.data);
						// if (data.frameHeight) {
						//     const iframe = document.getElementById('frame');
						//     iframe.style.height = evt.data.frameHeight + 'px';
						// }
						if (setFrameHeight && data?.frameHeight) {
							// Update the iframe height state based on the message from the child
							if(data?.frameHeight < 800){
								setFrameHeight('800px');
							}
							else{
								setFrameHeight(data?.frameHeight + 'px');
							}
						}
					}
				} catch (e) {
					// console.log("evt parsing error", e)
					// console.log(e);
				}
			}
	
	
			return () => {
				window.removeEventListener("message", receivedMessage, false);
			};
		}, []);
}

function useDebounce(value, delay = 500) {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay);
        
		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);

	return debouncedValue;
}

const useDebounceWithUseEffectDetection=(effect, dependencies, delay=400)=> {
    const callback = useRef(effect);

    useEffect(() => {
        callback.current = effect;
    }, [effect]);

    useEffect(() => {
        const handler = setTimeout(() => {
            callback.current();
        }, delay);

        return () => clearTimeout(handler); // Cleanup timeout on dependency change
    }, [...dependencies, delay]);
}

// Deep comparison helper
function isEqual(obj1, obj2) {
  return JSON.stringify(obj1) === JSON.stringify(obj2);
}

// Deep debounce hook
 function useDebounceDeep(value, delay = 500) {
  const [debouncedValue, setDebouncedValue] = useState(value);
  const prevValueRef = useRef(value);

  useEffect(() => {
	if (isEqual(prevValueRef.current, value)) return; //  Skip identical content

	const handler = setTimeout(() => {
	  setDebouncedValue(value);
	  prevValueRef.current = value;
	}, delay);

	return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
}



const useApplyTheme = (theme) => {
	document.documentElement.style.setProperty('--primary-color', theme.primaryColor || '#F77200');
	document.documentElement.style.setProperty('--secondary-color', theme.secondaryColor || '#2052bd');
	document.documentElement.style.setProperty('--light-orange', theme.lightOrange || '#f3d7c0');
	document.documentElement.style.setProperty('--light-coral', theme.lightCoral || '#E37B7B');
	document.documentElement.style.setProperty('--orange-brown', theme.orangeBrown || '#B96928');
	document.documentElement.style.setProperty('--dark-red', theme.darkRed || '#B92828');
	document.documentElement.style.setProperty('--dark-orange', theme.darkOrange || '#f36c00');
	document.documentElement.style.setProperty('--orange-shadow', theme.orangeShadow || '#c95c03');
	document.documentElement.style.setProperty('--light-green', theme.lightGreen || '#c4e4d570');
	document.documentElement.style.setProperty('--black', theme.black || '#000000');
	document.documentElement.style.setProperty('--gray', theme.gray || '#D9D9D9');
	document.documentElement.style.setProperty('--dark-gray', theme.darkGray || '#808080');
	document.documentElement.style.setProperty('--red', theme.red || '#FF0000');
	document.documentElement.style.setProperty('--yellow', theme.yellow || '#FFFF00');
	document.documentElement.style.setProperty('--green', theme.green || '#069306');
	document.documentElement.style.setProperty('--error-color', theme.error || '#d32f2f');
	document.documentElement.style.setProperty('--white', theme.white || '#FFFFFF');
	document.documentElement.style.setProperty('--text-color', theme.text || '#3b3434de');
	document.documentElement.style.setProperty('--shadow-color', theme.shadow || '#1a1a1a');
	document.documentElement.style.setProperty('--primary-light-color', theme.primaryLightColor || '#FF9000');

};
  
export { useDebounce,useWindowOpener,useDebounceWithUseEffectDetection,useApplyTheme,useIframeHandler,useDebounceDeep };
